module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notes-container"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.data.value),
      callback: function($$v) {
        _vm.$set(_vm.data, "value", $$v)
      },
      expression: "data.value"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px",
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.data.value == _vm.previousValue,
      "type": "success",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.saveClicked()
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('graphs/markersCat/save')))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fb7eb18","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/graphs/GraphNotes.vue
// module id = 446
// module chunks = 1